import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IEntitySearch,IEntityParams,IEntityDetail,IEntityInsert,IEntityUpdata,IEntityDisable} from "./entityTypes"
class EntityService {
    async page(params:IEntitySearch){
        const apiUrl = "/md/be/page"
        return await httpRequest.post<IPage<IEntityDetail>>(apiUrl,params)
    }
    async insert(params:IEntityInsert){
        const apiUrl = "/md/be/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IEntityUpdata){
        const apiUrl = "/md/be/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IEntityDisable){
        const apiUrl = "/md/be/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const entityService = new EntityService()
export {
    entityService
}